
<div class="container-fluid">
    <img id="logo" src="/assets/img/logo/LogoElmec.png" alt="Logo">

    <div class="center">
        <span id="title">
            <span translate>INVITATION.OWNERSHIP_TRANSFER</span>
            <span style="color: red;" translate>INVITATION.DECLINED</span>
        </span>
    </div>
    <div class="center">
        <span id="main-text">
            <span translate>INVITATION.DECLINED_DESCRIPTION_1</span>
            <span style="color: red;" translate>INVITATION.DECLINED_DESCRIPTION_2</span>
            <span translate>INVITATION.DECLINED_DESCRIPTION_3</span>
            <span translate><b>{{ stationName }}</b></span>
            <span translate>INVITATION.DECLINED_DESCRIPTION_4</span>
            <span translate><b>{{ currentOwnerName }}</b></span>
        </span>
    </div>
    <div class="center">
        <span id="main-text">
            <span translate>INVITATION.DECLINED_DESCRIPTION_5</span>
        </span>
    </div>

    <div class="center">
        <span id="sub-text">
            <span translate>INVITATION.CLOSE_WEBPAGE</span>
        </span>
    </div>
</div>